import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { getServerDataList, getServerDataListCurrency } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "serverDimensionData",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      more: true,
      value2: [],
      searchData: {
        server_id: [],
        scope: '',
        starttime: ''
      },
      PrimitiveserverLists: [],
      serverLists: [],
      tableData: [],
      Dynamic: [],
      isServer: false
    };
  },
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';
    this.getServerLists();

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }

    this.isServer = this.rawData.game_mark.indexOf('royalpirates') > -1 || this.rawData.game_mark.indexOf('yjfm') > -1 ? true : false;
    this.getsearchDate();
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  methods: {
    getsearchDate: function getsearchDate() {
      var now = new Date(this.$times.zeroTimeZone());
      var year = now.getFullYear();
      var month = (now.getMonth() + 1).toString().length < 2 ? "0" + (now.getMonth() + 1) : now.getMonth() + 1;
      var date = now.getDate().toString().length < 2 ? "0" + now.getDate() : now.getDate();
      var date = year + "-" + month + "-" + date;
      this.searchData.starttime = date;
    },
    getServerList: function getServerList() {
      var _this = this;

      var env_id = this.propsData ? this.propsData.env_id : this.searchData.env_id;
      yjServerList({
        server_channel: this.server_channel,
        show_test: this.show_test,
        env_id: env_id,
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.code == 200) {
          _this.serverListYJ = res.data;
        }
      });
    },
    //请求服务器列表  用于指定海盗和御剑请求
    getServerLists: function getServerLists() {
      this.RollSuit = false;
      this.serverLists = [];
      this.searchData.server_id = [];
      this.searchData.is_prod = '';
      var game = this.rawData.game_mark;

      if (game.indexOf(this.royalpirates) > -1) {
        this.RollSuit = this.severlist.length ? true : false;
      } else if (game.indexOf('yjfm') > -1) {
        this.RollSuit = true;
      }
    },
    searchChange: function searchChange(e) {
      this[e.type] = e.data instanceof Array ? e.data : _objectSpread(_objectSpread({}, this.searchData), e.data);
      this.screensever();
    },
    DataChange: function DataChange() {
      this.screensever();
    },
    severlistChange: function severlistChange(e) {
      var _this2 = this;

      this.PrimitiveserverLists = [];
      this.serverLists = [];
      this.searchData.server_id = [];

      if (e) {
        hdServerList({
          is_prod: this.searchData.is_prod
        }).then(function (res) {
          if (res.status == 200) {
            res.data.map(function (i) {
              i.openTime = i.openTime ? _this2.$times.dateTimeToTimeStamp(_this2.$times.formDate(i.openTime)) : "/";
            });
            _this2.PrimitiveserverLists = res.data;

            _this2.screensever();
          }
        });
      }
    },
    screensever: function screensever() {
      if (!this.value2[0]) {
        return;
      }

      var list = [];
      var timeData = {
        startTime: this.$times.dateTimeToTimeStamp(this.value2[0] + " 00:00:00"),
        endTime: this.$times.dateTimeToTimeStamp(this.value2[1] + " 23:59:59")
      };
      this.PrimitiveserverLists.forEach(function (i) {
        if (timeData.startTime <= i.openTime && timeData.endTime >= i.openTime) {
          list.push(i);
        }
      });
      this.serverLists = list;
    },
    searchClick: function searchClick() {
      var _this3 = this;

      // if(this.currencyClose && !this.searchData.currency_info){
      //   this.$message.error('请选择货币类型')
      //   return
      // }
      if (this.paramsData.server_id) {
        this.searchData.server_id = this.paramsData.server_id;
      } else {
        this.searchData.server_id = "";
      }

      if (this.rawData.game_mark.indexOf('yjfm') == -1) {
        this.searchData.is_prod = this.paramsData.is_prod;
      }

      var data = JSON.parse(JSON.stringify(this.searchData)); // if (this.value2.length == 0) {
      //   this.$message.error('请选择时间')
      //   return
      // }

      if (!this.searchData.starttime) {
        this.$message.error(this.$t('pleaseSelectTime'));
        return;
      }

      if (this.rawData.game_mark.indexOf('royalpirates') > -1 && !data.is_prod) {
        this.$message.error(this.$t('selectEnvironment'));
        return;
      }

      if (data.server_id.length == 0) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      if (!data.scope) {
        this.$message.error(this.$t('pleaseInputScope'));
        return;
      }

      if (data.scope.indexOf(',') > -1) {
        var str = data.scope.split(',');
        var strOne = '';
        str.map(function (i) {
          if (i) {
            strOne += i + ',';
          }
        });
        data.scope = strOne.substring(0, strOne.length - 1);
      }

      this.reqLoading = true; // data.starttime = this.value2[0];
      // data.endtime = this.value2[1];
      // if(data.server_id.length == 0 ){
      //   data.server_id = this.serverLists.map(i=>{return i.serverID})
      // }

      var reqFn = this.currencyClose ? getServerDataListCurrency : getServerDataList;
      reqFn(_objectSpread(_objectSpread({}, data), this.defaultData())).then(function (res) {
        if (res.status == 200) {
          // let list = this.serverLists.length ? this.serverLists : this.serverListYJ
          var list = _this3.rawData.game_mark.indexOf('royalpirates') > -1 ? _this3.serverList : _this3.serverListYJ;
          res.data.map(function (i) {
            i.serverName = list.find(function (j) {
              return j.serverID == i.server_id;
            }).serverName;
            i.openTime = list.find(function (j) {
              return j.serverID == i.server_id;
            }).openTimeFormat ? list.find(function (j) {
              return j.serverID == i.server_id;
            }).openTimeFormat : '/';
            i.amount = _this3.$utils.conversion(i.amount);
          });
          _this3.tableData = res.data;

          _this3.$nextTick(function () {
            _this3.getTableRight();
          });
        }
      }).finally(function () {
        _this3.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('serverName'),
        prop: 'serverName'
      }, {
        label: this.$t('openServerTime'),
        prop: 'openTime'
      }, {
        label: this.$t('days'),
        prop: 'day'
      }, {
        label: this.$t('registerNumColumnText'),
        prop: 'new'
      }, {
        label: this.$t('rechargePeopleNum'),
        prop: 'recharge'
      }, {
        label: this.$t('payAmount'),
        prop: 'amount'
      }];
      this.$export.excel({
        columns: columns,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};